import React from "react";
import Select from "../../../form/Select";
import Button from "../../../form/Button";
import Icon from "../../../form/Icon";
import QueryBuilder from "../NewsLetter/QueryBuilder/QueryBuilder";

const queryFields = [
    {
        components: {
            purchase: {
                name: 'totalprice',
                label: 'Kosárérték (levonás után)',
            }
        },
        operators: [
            {
                name: '>=',
                label: 'több vagy egyenlő, mint'
            },
            {
                name: '<',
                label: 'kevesebb, mint'
            },
        ]
    },
    {
        components: {
            purchase: {
                name: 'original_totalprice',
                label: 'Kosárérték (levonás előtt)',
            }
        },
        operators: [
            {
                name: '>=',
                label: 'több vagy egyenlő, mint'
            },
            {
                name: '<',
                label: 'kevesebb, mint'
            },
        ]
    },
    {
        components: {
            purchase: {
                name: 'items.base_product_id',
                label: 'Termékek',
            },
            product: {
                name: 'base_product_id',
                label: 'Termékek',
            }
        },
        operators: [
            {
                name: 'in',
                label: 'egyike'
            },
            {
                name: 'notIn',
                label: 'nem'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="Product"
                    storeType="remote"
                    placeholder="Termékek"
                    isMulti={true}
                    label={false}
                    value={props.value}
                    objectValue={false}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        components: {
            purchase: {
                name: 'items.authors.author_id',
                label: 'Szerzők',
            },
            product: {
                name: 'authors.author_id',
                label: 'Szerzők',
            },
        },
        operators: [
            {
                name: 'in',
                label: 'egyike'
            },
            {
                name: 'notIn',
                label: 'nem'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="Author"
                    storeType="remote"
                    placeholder="Szerzők"
                    isMulti={true}
                    label={false}
                    value={props.value}
                    objectValue={false}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        components: {
            purchase: {
                name: 'items.category',
                label: 'Árutípusok',
            },
            product: {
                name: 'category',
                label: 'Árutípusok',
            },
        },
        operators: [
            {
                name: 'in',
                label: 'egyike'
            },
            {
                name: 'notIn',
                label: 'nem'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="ProductCategory"
                    storeType="local"
                    placeholder="Árutípusok"
                    isMulti={true}
                    label={false}
                    value={props.value}
                    objectValue={false}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        components: {
            purchase: {
                name: 'items.tags',
                label: 'Címkék',
            },
            product: {
                name: 'tags',
                label: 'Címkék',
            },
        },
        component_type: ['product', 'purchase'],
        operators: [
            {
                name: 'in',
                label: 'egyike'
            },
            {
                name: 'notIn',
                label: 'nem'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="Tag"
                    storeType="remote"
                    placeholder="Címkék"
                    isMulti={true}
                    label={false}
                    value={props.value}
                    objectValue={false}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        components: {
            purchase: {
                name: 'items.series',
                label: 'Sorozatok',
            },
            product: {
                name: 'series',
                label: 'Sorozatok',
            },
        },
        operators: [
            {
                name: 'in',
                label: 'egyike'
            },
            {
                name: 'notIn',
                label: 'nem'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="Series"
                    storeType="local"
                    placeholder="Sorozatok"
                    isMulti={true}
                    label={false}
                    value={props.value}
                    objectValue={false}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        components: {
            purchase: {
                name: 'items.tradename',
                label: 'Kiadók',
            },
            product: {
                name: 'tradename',
                label: 'Kiadók',
            },
        },
        operators: [
            {
                name: 'in',
                label: 'egyike'
            },
            {
                name: 'notIn',
                label: 'nem'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="Tradename"
                    storeType="remote"
                    placeholder="Kiadók"
                    isMulti={true}
                    label={false}
                    value={props.value}
                    objectValue={false}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        components: {
            purchase: {
                name: 'items.listprice',
                label: 'Termék listaára',
            },
            product: {
                name: 'listprice',
                label: 'Termék listaára',
            },
        },
        operators: [
            {
                name: '>=',
                label: 'több vagy egyenlő, mint'
            },
            {
                name: '<',
                label: 'kevesebb, mint'
            },
        ]
    }
];

export default class LoyaltyPointDiscountRuleConditions extends React.Component {

    constructor(props) {
        super(props);
        if (!this.props.value) {
            this.props.saveChanges(this.props.name, {
                filters: [],
                operator: "OR"
            });
        }
    }


    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.props.value) {
            this.props.saveChanges(this.props.name, {
                filters: [],
                operator: "OR"
            });
        }
    }

    render() {
        const filter = JSON.parse(JSON.stringify(this.props.value || {
            filters: [],
            operator: "OR"
        }));
        const paramsProps = {
            name: this.props.name,
            value: filter,
            saveChanges: (field, value) => {
                this.props.saveChanges(field, value);
            },
            tabLabel: "Feltételek"
        };
        const fields = 
            queryFields.filter((field) => Object.keys(field.components).includes(this.props.component_type))
                .map((field) => {
                    field.name = field.components[this.props.component_type].name;
                    field.label = field.components[this.props.component_type].label;
                    return field;
                })
        return (
            <div className="row">
                <div className="col-md-12">
                    <QueryBuilder {...paramsProps} fields={ fields} />
                </div>
            </div>
        );
    }
}